import {createReducer} from '@reduxjs/toolkit'
import {
    dPosConfigurationClearFiltersAC,
    dPosConfigurationSetDataAC,
    dPosConfigurationSetDetailItemAC,
    dPosConfigurationSetFiltersAC, dPosConfigurationSetFullDetailItemAC,
} from './dPosConfigurationActionCreators'
import {logoutAC} from 'model/system/systemActionCreators';


// Type
export type IdPosConfigurationStateDataItem = {
    id: string,
    name: string,
    storeIds: string[],
    posIds: string[],
    posCategories: typePosCategoriesItem[],
}

export type typePosCategoriesItem = {
    id: string,
    name: string,
    productIds: string[],
}
export type typePosItem = {
    id: string,
    fiscalCardId: string,
    posHardwareModel: string,
    posHardwareSerialNumber: string,
}
export type typePosStoreItem = {
    id: string,
    name: string,
}
export type IdPosConfigurationStateDataFullItem = {
    configuration: {
        id: string,
        name: string,
        storeIds: string[],
        posIds: string[],
        posCategories: typePosCategoriesItem[],
    },
    pos: typePosItem[],
    store: typePosStoreItem[],
}


export type IdPosConfigurationState =  {
    data: IdPosConfigurationStateDataItem[],
    detailItem: IdPosConfigurationStateDataItem | undefined,
    fullDetailItem: IdPosConfigurationStateDataFullItem | undefined,
    filters: typePosConfigurationFilters
}

export type typePosConfigurationFilters = {
    name?: string | null,
    storeId?: string | null,
    posId?:  string | null,
}

// Clean filter object
export const cleanFilterObject: typePosConfigurationFilters = {
    name: null,
    storeId: null,
    posId: null,
}


// Init state
export const initialState: IdPosConfigurationState = {
    data: [],
    detailItem: undefined,
    fullDetailItem: undefined,
    filters: cleanFilterObject
}


// Reducer
export const DPosConfigurationReducer = createReducer(initialState, builder => {
    builder

        // Reducer of set data
        .addCase(dPosConfigurationSetDataAC, (state, action) => {
            state.data = action.payload.dataList
        })


        // Reducer of set detail item
        .addCase(dPosConfigurationSetDetailItemAC, (state, action) => {
            state.detailItem = state.data.find((item) => item.id === action.payload)
        })

        // Reducer of set full detail item
        .addCase(dPosConfigurationSetFullDetailItemAC, (state, action) => {
            state.fullDetailItem = action.payload
        })

        // Reducer of clear filtersForm
        .addCase(dPosConfigurationClearFiltersAC, (state) => {
            state.filters = cleanFilterObject
        })

        // Reducer of set filters
        .addCase(dPosConfigurationSetFiltersAC, (state, action) => {
            state.filters = {...state.filters, ...action.payload}
        })
        // Reducer of clear state
        .addCase(logoutAC, ( state ) => {
            state.data = initialState.data
            state.detailItem=initialState.detailItem
            state.filters = initialState.filters
            state.fullDetailItem=undefined
        })
})
